import React, { useRef, useState, useEffect } from 'react';
import { Modal, FormGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import Select from 'react-select';
import Loader from '../../../../Components/Utility/Loader/Loader';
import UploadFileAndDocument from '../../../../Components/UploadFileAndDocument/UploadFileAndDocument';
import { customStyles } from '../../../../Components/helper';
import * as action from '../Store/PurchaseOrder.action';

const statusOption = [
  { _id: 1, name: 'Approved' },
  { _id: 2, name: 'Rejected' },
  { _id: 3, name: 'Not Applicable' },
];

function UploadDocuments({ onOpen, toggle, showData }) {
  const { t } = useTranslation('common');
  const childRef = useRef();
  const dispatch = useDispatch();
  const { devOrderId } = useParams();
  const {
    UserDetails: { isSupplierLoggedIn },
  } = useSelector((reduxState) => reduxState);

  const [state, setState] = useState({
    name: '',
    notes: '',
    isVisibletoSupplier: '',
    status: null,
    loading: false,
    fromSubmit: false,
    fileMissing: false,
  });
  const [fileName, setFileNames] = useState('');
  const addDocument = async () => {
    setState((submitState) => ({
      ...submitState,
      fromSubmit: true,
    }));
    const formData = new FormData();
    if (childRef?.current) {
      const uploadedDoc = await childRef?.current?.selectedDocument();
      let err = false;
      if (uploadedDoc) {
        const { document } = uploadedDoc;
        formData.append('devOrderId', devOrderId);
        formData.append('poId', showData?._id);
        formData.append('status', state.status?.name);
        formData.append('notes', state.notes);
        formData.append('fileName', state.name);
        formData.append('isVisibleToSupplier', state.isVisibletoSupplier);
        formData.append('isPoType', true);
        formData.append('document', document);
      } else {
        err = true;
      }
      if (state.name.trim()) {
        apiCalls(err, formData);
      }
    } else {
      setState((errState) => ({ ...errState, fileMissing: true }));
    }
  };
  useEffect(() => {
    setState((hasFile) => ({
      ...hasFile,
      name: fileName,
    }));
  }, [fileName]);

  const apiCalls = async (err, formData) => {
    if (!err) {
      setState((hasFile) => ({
        ...hasFile,
        loading: true,
      }));
      const res = await dispatch(action.postPODocuments(formData, t));
      if (res) {
        setState((hasFile) => ({
          ...hasFile,
          loading: false,
        }));
        toggle();
      }
    }
  };

  const inputChanges = (e) => {
    if (e?.target?.name === 'documentName') {
      setState((previousNames) => ({
        ...previousNames,
        name: e.target.value,
      }));
    } else {
      setState((previousNotes) => ({
        ...previousNotes,
        notes: e.target.value,
      }));
    }
  };

  const onStatusChange = (e) => {
    setState((stated) => ({
      ...stated,
      status: e,
    }));
  };

  const handlecheckBox = (e) => {
    setState((visibileState) => ({
      ...visibileState,
      isVisibletoSupplier: e?.target?.checked,
    }));
  };

  return (
    <Modal className="custom-modal modal-medium-3x supplier-overview-modal" size="lg" show={onOpen} onHide={toggle} backdrop="static" centered>
      <Modal.Header>
        <Modal.Title>{t('TAKING_DATES.UPLOAD_DOCUMENTS')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {state.loading ? (
          <Loader />
        ) : (
          <>
            <UploadFileAndDocument
              showTitleField={false}
              ref={childRef}
              acceptedFileExtenstion=".xls, .xlsx, .pdf, .psd, .doc, .txt, .rar, .png, .jpeg, .jpg, .bmp, .tif, .raw, .etc, .gif, .ppt, .svg, .exp"
              setFileNames={setFileNames}
              fromPO
            />
            {state.fileMissing && <small className="error-message">{t('FILTER.PLEASE_SELECT_FILE')}</small>}
            <div className="mt-3">
              <FormGroup>
                <div>
                  <input
                    type="text"
                    name="documentName"
                    placeholder={t('FILTER.DOCUMENT_TITLE')}
                    value={state.name}
                    className="form-control text-bordered"
                    onChange={inputChanges}
                  />
                </div>
                {isEmpty(state.name) && state.fromSubmit && <small className="error-message">{t('FILTER.PLEASE_ENTER_DOCUMENT_TITLE')}</small>}
              </FormGroup>
            </div>
            <div className="mt-3">
              <FormGroup>
                <label>{t('FILTER.NOTES')}</label>
                <div>
                  <input type="text" name="notes" placeholder={t('FILTER.NOTES')} value={state.notes} className="form-control" onChange={inputChanges} />
                </div>
              </FormGroup>
            </div>
            <div className="mt-3">
              <FormGroup>
                <div>
                  <Select
                    name="status"
                    maxMenuHeight={132}
                    menuPlacement="top"
                    menuPosition="fixed"
                    options={statusOption}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    value={state.status}
                    styles={customStyles}
                    onChange={(e) => onStatusChange(e)}
                    placeholder={t('PROGRESS_INDICATOR.SELECT_STATUS')}
                  />
                </div>
              </FormGroup>
            </div>
            {isSupplierLoggedIn ? (
              <></>
            ) : (
              <div className="checkbox-label">
                <input type="checkbox" id="visibility" checked={state.isVisible} onClick={handlecheckBox} name="change Status" />
                <label htmlFor="visibility" className="chklabel">
                  <span>{t('FILTER.VISIBLE_TO_SUPPLIER')}</span>
                </label>
              </div>
            )}
            <div className="modal-buttons mt-3 d-flex justify-content-between">
              <button className="btn btn-default" type="button" onClick={toggle}>
                {t('FILTER.BACK')}
              </button>
              <button className="btn btn-default" type="button" onClick={addDocument} disabled={state.fileMissing}>
                {t('SPEC_TEMP_LIBRARY.ADD')}
              </button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default UploadDocuments;
